<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

  export default {
    name: "App",
    data() {
      return {};
    },
  }
</script>
<style lang="less">
  @import "./assets/css/global";

  body {
    background-color: #F5F5F5;
    height: 100%;
    margin: 0;
    padding: 0;
  }


  * {
    margin: 0;
    padding: 0;
  }

  #app {
    min-width: 375px;
    /*height: 100%;*/
    min-height: 100%;
    /*overflow-x: hidden;*/
    margin-left: auto;
    margin-right: auto;
  }

</style>
